import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { GatherContractsRoutes } from '../../checklist-section-gather-contracts/gather-contracts-routes';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  selector: 'aux-gather-contract-row-title',
  styles: [
    `
      :host {
        flex-grow: 1;

        .link {
          color: rgba(9, 91, 149);
        }
      }
    `,
  ],
  template: `
    Pending
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="GatherContractsRoutes.CHANGE_ORDER"
    >
      Change Orders
    </span>
    <span>{{ ', ' }}</span>
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="GatherContractsRoutes.PURCHASE_ORDERS"
    >
      Purchase Orders
    </span>
    <span>{{ ', New ' }}</span>
    <span class="btn--hyperlink cursor-pointer px-0" [routerLink]="GatherContractsRoutes.VENDORS">
      Vendor Contracts
    </span>
    <span>{{ ', or ' }}</span>
    <span class="btn--hyperlink cursor-pointer px-0" [routerLink]="GatherContractsRoutes.BUDGET">
      Vendor Budgets
    </span>
  `,
})
export class GatherContractRowTitleComponent {
  readonly GatherContractsRoutes = GatherContractsRoutes;
}
